import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { mergeMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators';
import { VehicleService } from '../services/vehicle.service';
import * as VehicleActions from '../actions/vehicle.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';

@Injectable()
export class VehicleEffects {
    constructor(private actions$: Actions, private vehicleService: VehicleService, private store: Store<AppState>) { }

    loadVehicles$ = createEffect(() =>
        this.actions$.pipe(
            ofType(VehicleActions.loadVehicles),
            withLatestFrom(this.store.select(state => state.main.vehicles)),
            filter(([action, vehicles]) => !vehicles || vehicles.length === 0), // only continue if it was not loaded before
            mergeMap(([action, vehicles]) => {
                const { organizationId, clientId } = action; // Extract the organizationId from the action

                return  this.vehicleService.getVehicles(organizationId, clientId ).pipe(
                    map(vehicles => VehicleActions.loadVehiclesSuccess({ vehicles })),
                    catchError(error => of(/* handle error action */))
                )
            })
        )
    );
}
